/**
 * Created by pandemio on 9/23/18.
 */
import React from 'react';
import { Button, Table, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import PrintPDF from '../print/print-pdf';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from "../../custom-classes/api-calls";
import ResultsToHTMLConverter from "../../custom-classes/results-html-converter";

/**
 * Class that handles the modal
 */
class TableTotalTries extends React.Component {
    constructor(props) {
        super(props);
        let languages = [
            { name: "English", code: "en" },
            { name: "Español", code: "es" }
        ];
        this.state = {
            rows: [],
            modal: false,
            triesData: this.props.data,
            languages: languages,
            tryId: null,
            examInfo: null
        };

        this.toggle = this.toggle.bind(this);
        this.callResults = this.callResults.bind(this);
    }

    /** Handle the updates
     * We cannot find a concrete response why this is needed here meanwhile the other selector components are not needed.
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        this.setState({triesData: nextProps.data},
            ()=>{
                this.mountData();
        });
    }

    /**
     * Prepare it for the first view with the data included
     */
    componentWillMount(){
        this.mountData();
    }

    /**
     * Loads the results of the try
     */
    callResults(param){
        // Call the results
        let apiCall = ApiCalls.getUserQuizDetails(param);
        apiCall.then((results)=>{
            let resultsHtml = ResultsToHTMLConverter.getHtmlResults(results.UserQuizFullDetails, results.StudentName, this.state.languages);
            this.setState({examInfo:resultsHtml});
        });

        this.setState({
            modal: !this.state.modal,
            tryId: param
        });
    };


    /**
     * Hide or shows the message window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    /**
     * Mounts the data
     */
    mountData(){

        let rows = [];
        for(let i=0; i < this.state.triesData.length;i++)
        {
            // If active, add the button;
            let row = <tr key={this.state.triesData[i].Id}>
                <td>{this.state.triesData[i].TryNo}</td>
                <td>{this.state.triesData[i].TotalPercent}</td>
                <td>{this.state.triesData[i].CreatedAt}</td>
                <td>
                    <Button className="btn btn-info" onClick={()=>this.callResults((this.state.triesData[i].Id))}>
                        <Translate id="report-student-average.see-details" options={{renderInnerHtml: true}}/>
                    </Button>
                </td>
            </tr>;
            rows.push(row);
        }
        this.setState({rows:rows});
    }

    render() {
        return (
            <div>
                <Table className="card-white" responsive>
                    <thead>
                    <tr>
                        <th><Translate id="report-student-average.try" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="report-student-average.total" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="report-student-average.taken-date" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="report-student-average.print" options={{renderInnerHtml: false}}/></th>
                    </tr>
                    </thead>
                    <tbody>
                    { this.state.rows !== "0" ? this.state.rows : null }
                    </tbody>
                </Table>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-results">
                    <ModalHeader className="card-white" toggle={this.toggle}>
                        <Translate id="report-student-average.results" options={{renderInnerHtml: false}} />
                    </ModalHeader>
                    <ModalBody className="card-white">
                        { this.state.examInfo !== null ?
                            <div dangerouslySetInnerHTML={{ __html: (this.state.examInfo)}}/> : null }
                    </ModalBody>
                    <ModalFooter className="card-white">
                        { this.state.examInfo !== null ?
                        <PrintPDF data={this.state.examInfo} onClick={this.toggle} color="info">
                            <Translate id="report-student-average.print" options={{renderInnerHtml: false}} />
                        </PrintPDF> : null}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default TableTotalTries;


// WEBPACK FOOTER //
// ./src/components/tables/table-total-tries.js